module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-drawer"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-form', {
    ref: "searchForm",
    attrs: {
      "inline": ""
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.handleSaveClick
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-result"
  }, [_c('el-tree', {
    ref: "menuTree",
    attrs: {
      "props": _vm.menuTreeProps,
      "data": _vm.menuData,
      "node-key": "id",
      "show-checkbox": ""
    }
  })], 1)])]), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmSaveVisible,
      "confirm": _vm.handlerSaveConfirmOK,
      "appendToDialog": ""
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmSaveVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmSaveVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n        确认保存？\n      ")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-454b3b23", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-454b3b23","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/sysmanagement/role/roleprivilege.vue
// module id = 1569
// module chunks = 7